import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "hero-body has-text-centered" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "title" }, "Connect Wallet to Continue", -1)
const _hoisted_3 = { class: "subtitle" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("p", _hoisted_3, [
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.$root.connectWallet && _ctx.$root.connectWallet(...args))),
        class: "button is-large"
      }, "Connect")
    ])
  ]))
}